// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"68":"2eaf0f4f","730":"2eaf0f4f","811":"18a4d20a","935":"9cee985b"}[chunkId] + ".css";
};